import * as THREE from 'three';
import TriangleMesh from '../representation3d/TriangleMesh';

export default class TriangleMeshGeometry {
    static create(triangleMesh: TriangleMesh, material: THREE.Material, layer: number): THREE.Mesh {
        const { vertices, indices, normals } = triangleMesh;

        let geometry = new THREE.BufferGeometry();
        geometry.setAttribute('position', new THREE.Float32BufferAttribute(vertices, 3));
        if (indices) geometry.setIndex(new THREE.BufferAttribute(indices, 1));
        geometry.setAttribute('normal', new THREE.Float32BufferAttribute(normals, 3));

        if ((material as THREE.MeshStandardMaterial).map) {
            // Each face needs its own UVs, so vertices can't be shared between faces
            geometry = geometry.toNonIndexed();
            geometry.computeVertexNormals();
            TriangleMeshGeometry.setPlanarUvs(geometry);
        } else {
            geometry.computeVertexNormals();
        }

        material.side = THREE.DoubleSide; // Temporary fix for invalid triangle normals
        const mesh = new THREE.Mesh(geometry, material);
        mesh.layers.set(layer);
        mesh.name = "TriangleMesh";
        
        return mesh;
    }

    // Projects each face onto the axis plane its normal is closest to, with UVs in scene units like
    // ExtrudeGeometry's, so textures tile at the same scale. Vertical faces get V along Z (up).
    private static setPlanarUvs(geometry: THREE.BufferGeometry) {
        const position = geometry.getAttribute('position');
        const normal = geometry.getAttribute('normal');
        const uvs = new Float32Array(position.count * 2);

        for (let i = 0; i < position.count; i++) {
            const nx = Math.abs(normal.getX(i)), ny = Math.abs(normal.getY(i)), nz = Math.abs(normal.getZ(i));
            const x = position.getX(i), y = position.getY(i), z = position.getZ(i);

            if (nz >= nx && nz >= ny)   { uvs[i * 2] = x; uvs[i * 2 + 1] = y; }
            else if (nx >= ny)          { uvs[i * 2] = y; uvs[i * 2 + 1] = z; }
            else                        { uvs[i * 2] = x; uvs[i * 2 + 1] = z; }
        }

        geometry.setAttribute('uv', new THREE.BufferAttribute(uvs, 2));
    }
}
